import React from "react";
import '../styles/Header.css';
import { getLogo } from "../helpers/Helper";

const Header = (props) => {
    return (
        <div className="header">
            <div className="logo-container">
                {getLogo()}
            </div>
            <div className="links-container">
                <a className="link" href={props.websiteUrl} target="_blank" rel="noopener noreferrer">Home</a>
                <a className="link" href={props.aboutUrl} target="_blank" rel="noopener noreferrer">About</a>
            </div>
        </div>
    )
}
export default Header;